import Intro from "../pages/Intro";
import Bots from "../pages/Bots";
import Coins from "../pages/Coins";
import Auth from "../pages/Auth";
import Lobbies from "../pages/Lobbies";
// import HelpCenterRouterOutlet from "../pages/HelpCenter";
import Dashboard from "../pages/Dashboard";
import CompleteProfile from "../pages/CompleteProfile";
import Notifications from "../pages/Notifications";
import Password from "../pages/Password";
import Leaderboard from "../pages/Leaderboard";
import LobbyList from "../pages/LobbyList";
import Bot from "../pages/Bot";
import SinglePlayer from "../pages/SinglePlayer";
import BotList from "../pages/BotList";
import QuoCoin from "../pages/QuoCoin";
import Activity from "../pages/Activity";
import Profile from "../pages/Profile";
import Lobby from "../pages/Lobby";
import Challenge from "../pages/Challenge";
import QuoQuestLanding from "../pages/QuoQuestLanding";
import QuoQuestLevels from "../pages/QuoQuestLevels";
import QuoQuestLevel from "../pages/QuoQuestLevel";
import QuoQuestLevelBot from "../pages/QuoQuestLevelBot";
import QuoQuestLevelStageGame from "../pages/QuoQuestLevelStageGame";
import LevelsModal from "../components/LevelsModal";
import HelpCenterPage from "../pages/HelpCenter";
import TradeInfo from "../pages/TradeInfo";

const routes = [
  {
    path: "/challenge*",
    component: Challenge,
    private: true
  },
  {
    path: "/quest",
    component: QuoQuestLanding,
    private: true
  },
  {
    path: "/quest/levels",
    component: QuoQuestLevels,
    private: true
  },
  {
    path: "/quest/levels/:levelId",
    component: QuoQuestLevel,
    private: true
  },
  {
    path: "/quest/levels/:levelId/:stageIndex",
    component: QuoQuestLevel,
    private: true
  },
  {
    path: "/quest/levels/:levelId/:stageIndex/bot",
    component: QuoQuestLevelBot,
    private: true
  },
  {
    path: "/quest/levels/:levelId/:stageIndex/game/:lobbyId",
    component: QuoQuestLevelStageGame,
    private: true
  },
  {
    path: "/intro",
    component: Intro
  },
  {
    path: "/auth",
    component: Auth
  },
  {
    path: "/completeProfile",
    component: CompleteProfile
  },
  {
    path: "/notifications",
    component: Notifications,
    private: true
  },
  {
    path: "/dashboard",
    component: Dashboard,
    private: true
  },
  {
    path: "/bots",
    component: Bots,
    private: true
  },
  {
    path: "/coins",
    component: Coins
  },
  {
    path: "/botList/:mode/:filter",
    component: BotList,
    private: true
  },
  {
    path: "/lobbyList/:type",
    component: LobbyList,
    private: true
  },
  {
    path: "/bots/:botId",
    component: Bot,
    private: true
  },
  {
    path: "/lobbies",
    component: Lobbies,
    private: true
  },
  {
    path: "/lobbies/:lobbyId",
    component: Lobby,
    private: true
  },
  {
    path: "/leaderBoard",
    component: Leaderboard,
    private: true
  },
  {
    path: "/helpCenter*",
    component: HelpCenterPage,
    private: true
  },
  {
    path: "/levels",
    component: LevelsModal,
    private: true
  },
  {
    path: "/quoCoin/:mode",
    component: QuoCoin,
    private: true
  },
  {
    path: "/quoCoin",
    component: QuoCoin,
    private: true
  },
  {
    path: "/activity",
    component: Activity,
    private: true
  },
  {
    path: "/profile",
    component: Profile,
    private: true
  },
  {
    path: "/password",
    component: Password
  },
  {
    path: "/bots/:botId/trades/:tradeId",
    component: TradeInfo
  },
  {
    path: "/",
    component: Dashboard,
    private: true
  },
  {
    path: "",
    component: Dashboard,
    private: true
  },
  {
    path: "/singlePlayer",
    component: SinglePlayer,
    private: true
  }
];

export default routes;
